module.exports = __webpack_public_path__ + "img/facebook.643561b6.svg";